<template>
    <v-dialog
    :value="value"
    @input="(v) => v || closeCreatePvsystLasDialog()"
    max-width="500px"
    >
    <v-card>
        <v-card-title>
          <span class="headline">点群ファイルを整理</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <v-form
              ref="createPvsystLasForm"
              v-model="createPvsystLasFormValid"
              lazy-validation
            >
              <span>* lasを選択してください。</span>
              <v-select
                hide-details="auto"
                v-model="las_path"
                label="lasファイル"
                :items="las_file"
                outlined
                clearable
                dense
                :rules="[v => !!v || 'lasファイルが必要です。']"
                required
              ></v-select>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn depressed @click="closeCreatePvsystLasDialog">キャンセル</v-btn>
          <v-btn depressed color="primary" @click="create">整理</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
</template>
<script>
import {store} from "@/store";
export default {
  name: "H2pCreatePvsystLasDialog",
  props: ["value", "las_file", "array_position_id"],
  data() {
    return {
      createPvsystLasFormValid: true,
      las_path: null,
    };
  },
  methods: {
    create() {
      if (this.$refs.createPvsystLasForm.validate()) {
        this.axios.post("/api/h2p/pvsyst-las/", {'las_path': this.las_path, 'array_position_id': this.array_position_id})
        .then((response) => {
            if (response.status) {
                store.showSuccessDialog("点群ファイルを整理中です。");
            }
            this.closeCreatePvsystLasDialog();
        });
      }
    },
    
    closeCreatePvsystLasDialog() {
      this.$refs.createPvsystLasForm.reset();
      this.$emit("input");
    },
  },
};
</script>
